import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

// Create base client
const baseClient = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Helper function to set mobile session via RPC
export const setMobileSession = async (mobileNumber) => {
  if (mobileNumber && typeof window !== 'undefined') {
    try {
      await baseClient.rpc('set_mobile_session', { mobile_num: mobileNumber });
    } catch (error) {
      console.error('Error setting mobile session:', error);
      // Don't throw - allow operation to continue
    }
  }
};

// Helper function to clear mobile session
export const clearMobileSession = async () => {
  if (typeof window !== 'undefined') {
    try {
      await baseClient.rpc('set_mobile_session', { mobile_num: null });
    } catch (error) {
      console.error('Error clearing mobile session:', error);
    }
  }
};

// Export base client directly - services handle session setting explicitly
// This avoids race conditions where queries execute before session is set
export const supabase = baseClient;